import { RECAPTCHA_VERSION, YANDEX_CAPTCHA_VERSION } from './Recaptcha.constants';

export const isYandexCaptcha = (productName: string): boolean => productName === 'Вейвсенд';

export const getCaptchaVersion = (productName: string): string => (
  isYandexCaptcha(productName) ? YANDEX_CAPTCHA_VERSION : RECAPTCHA_VERSION
);

// v3 site keys, one pair per brand — v2 keys do not work with the v3 API.
export const getMinifiedSiteKey = (productName: string): string => {
  if (productName === 'Pushwoosh') {
    return '6LeLCMktAAAAAN5482l2V33scwNdUZ0kkHYfVOgw';
  }

  if (productName === 'PushwooshUS') {
    return '6LdrCcktAAAAAFZTb3IpZ8EdJdJVpvIatdsVUC5P';
  }

  return '6LfeCcktAAAAALvgLuSHOj3a3cnSVHU6rSSO56Oh';
};

export async function asyncScriptLoad(scriptUrl: string): Promise<Event | void> {
  return new Promise((
    resolve,
    reject,
  ) => {
    const isAlreadyLoaded = document.querySelector(`script[src="${scriptUrl}"]`);
    if (isAlreadyLoaded) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    document.body.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
  });
}
